// useDarkMode.ts
import { ref, watchEffect, onMounted } from 'vue'

interface UseDarkModeOptions {
  selector?: string // 要应用暗黑模式的根元素选择器，默认是html
  storageKey?: string // 本地存储的键名
  darkClass?: string // 暗黑模式应用的CSS类名
}

export function useDarkMode(options: UseDarkModeOptions = {}) {
  const { selector = 'html', storageKey = 'vue-dark-mode', darkClass = 'dark' } = options

  const isDarkMode = ref(false)
  const rootElement = ref<HTMLElement | null>(null)

  // 初始化
  onMounted(() => {
    rootElement.value = document.querySelector(selector)

    // 从本地存储或系统偏好中获取初始值
    const storedPreference = localStorage.getItem(storageKey)

    if (storedPreference !== null) {
      isDarkMode.value = storedPreference === 'true'
    } else {
      // 默认就是非暗黑模式
      isDarkMode.value = false
    }
  })

  // 监听isDark变化并应用类
  watchEffect(() => {
    if (!rootElement.value) return

    if (isDarkMode.value) {
      rootElement.value.classList.add(darkClass)
    } else {
      rootElement.value.classList.remove(darkClass)
    }

    // 存储用户偏好
    localStorage.setItem(storageKey, String(isDarkMode.value))
  })

  // 切换函数
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value
  }

  return {
    isDarkMode,
    toggleDarkMode,
  }
}
